module.exports = __webpack_public_path__ + "fonts/ITC Avant Garde Gothic Medium.woff";